import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ConditionalView } from "@jti/rip";
import { ColorSelector, TitleBorderContainer, Typography } from "@jti/ui-library";
import { getOptionsForColorSelector } from "../../utils/getOptionsForColorSelector";
import styles from "./ProductConfigurableBlock.module.scss";
const getCurrentOption = (options, value) => options.find(({ id }) => id === value);
export const ProductConfigurableBlock = ({ label, options = [], value, stock }) => {
    if (options.length === 0) {
        return null;
    }
    const option = getCurrentOption(options, value);
    return (_jsxs(TitleBorderContainer, { title: label, children: [_jsx(ColorSelector, { config: getOptionsForColorSelector(options, false, stock), value: value, onChange: (option) => {
                    const selectedOption = options.find(({ label }) => label == option.label);
                    if (selectedOption) {
                        window.location.href = selectedOption.url;
                    }
                } }), _jsx(ConditionalView, { condition: !!option, children: _jsx(Typography, { variant: "subtitle", component: "span", className: styles.optionLabel, children: option?.label }) })] }));
};
//# sourceMappingURL=ProductConfigurableBlock.js.map